module.exports = __webpack_public_path__ + "img/illustration_waiting_process.b5497c57.svg";